import React, { useState } from "react";

const gridSize = 10;
const words = [
  ["அ", "க", "ர"],
  ["மு", "த", "ல"],
  ["எ", "ழு", "த்", "தெ", "ல்", "லா", "ம்"],
  ["ஆ", "தி"],
  ["ப", "க", "வ", "ன்"],
  ["மு", "த", "ற்", "றே"],
  ["உ", "ல", "கு"],
];
const tamilLetters = "அஆஇஈஉஊஎஏஐஒஓகஙசஞடணதநபமயரலவழளறன".split("");

const generateGrid = () => {
  let grid = Array.from({ length: gridSize }, () => Array(gridSize).fill(null));
  words.forEach((word) => {
    let placed = false;
    while (!placed) {
      let row = Math.floor(Math.random() * gridSize);
      let col = Math.floor(Math.random() * (gridSize - word.length));
      if (
        grid[row].slice(col, col + word.length).every((cell) => cell === null)
      ) {
        word.forEach((syllable, i) => {
          grid[row][col + i] = syllable;
        });
        placed = true;
      }
    }
  });
  return grid.map((row) =>
    row.map((cell) =>
      cell
        ? cell
        : tamilLetters[Math.floor(Math.random() * tamilLetters.length)]
    )
  );
};

const CustomButton = ({ onClick, children }) => (
  <button
    onClick={onClick}
    className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-700"
  >
    {children}
  </button>
);

const WordSearchGame = () => {
  const [grid, setGrid] = useState(generateGrid());
  const [selectedLetters, setSelectedLetters] = useState([]);
  const [foundWords, setFoundWords] = useState([]);
  const [highlightedCells, setHighlightedCells] = useState(new Set());

  const handleLetterClick = (row, col) => {
    const newSelection = [
      ...selectedLetters,
      { row, col, letter: grid[row][col] },
    ];
    setSelectedLetters(newSelection);
    const selectedWord = newSelection.map((item) => item.letter).join("");

    if (
      words.some((word) => word.join("") === selectedWord) &&
      !foundWords.includes(selectedWord)
    ) {
      setFoundWords([...foundWords, selectedWord]);
      setSelectedLetters([]);
      const newHighlightedCells = new Set(highlightedCells);
      newSelection.forEach(({ row, col }) =>
        newHighlightedCells.add(`${row}-${col}`)
      );
      setHighlightedCells(newHighlightedCells);
    }
  };

  return (
    <div className="flex flex-col items-center p-4 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-4">தமிழ் சொல் தேடல் விளையாட்டு</h1>
      <div className="grid grid-cols-10 gap-1">
        {grid.map((row, rowIndex) =>
          row.map((letter, colIndex) => (
            <div
              key={`${rowIndex}-${colIndex}`}
              onClick={() =>
                !highlightedCells.has(`${rowIndex}-${colIndex}`) &&
                handleLetterClick(rowIndex, colIndex)
              }
              className={`w-14 h-14 flex items-center justify-center border cursor-pointer bg-white text-lg font-bold ${
                selectedLetters.some(
                  (sel) => sel.row === rowIndex && sel.col === colIndex
                )
                  ? "bg-yellow-300"
                  : ""
              } ${
                highlightedCells.has(`${rowIndex}-${colIndex}`)
                  ? "bg-green-400 cursor-not-allowed"
                  : ""
              }`}
            >
              {letter}
            </div>
          ))
        )}
      </div>
      <div className="mt-4">
        <h2 className="text-lg font-semibold">இந்த சொற்களை தேடுங்கள்:</h2>
        <ul className="list-disc">
          {words.map((word) => (
            <li
              key={word.join("")}
              className={
                foundWords.includes(word.join(""))
                  ? "text-green-600 font-bold"
                  : "text-blue-600 font-semibold"
              }
            >
              {word.join("")}
            </li>
          ))}
        </ul>
      </div>
      <CustomButton
        onClick={() => {
          setGrid(generateGrid());
          setFoundWords([]);
          setSelectedLetters([]);
          setHighlightedCells(new Set());
        }}
      >
        புதிய விளையாட்டு
      </CustomButton>
    </div>
  );
};

export default WordSearchGame;
